import { Footer } from "../components/Footer"
import { PriorityMethods } from "../components/deposit/PriorityMethods"
import { R4DebitoInmediato } from "../components/deposit/R4DebitoInmediato"


export const DepositR4DebitoInmediatoPage = () => {
    return (
        <div className="container">
            <PriorityMethods />
            <R4DebitoInmediato />
            <Footer />
        </div>
    );
}